import store from "./store";

export const DocumentStore = store("supplier");
export const BookingContractStore = store("booking_contracts");
export const BookingInvoiceStore = store("booking_invoices");
export const FinanceDocumentStore = store("finance");

export { default as DocumentsHeader } from "./components/DocumentsHeader";
